import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useAuth } from "../AuthContext";
import axios from "axios";
// import iziToast from "izitoast";

export const MyTest = () => {
    const { apipath, filepath } = useAuth();
    const navigate = useNavigate();
    const token = localStorage.getItem('token');
    const tId = localStorage.getItem('tId');
    const [questionsData, setQuestionsData] = useState([]);
    const [testData, setTestData] = useState();
    const [totalQuestions, setTotalQuestions] = useState(0);
    const [imgpath, setImgpath] = useState("");
    const [timeLeft, setTimeLeft] = useState(() => {
        // Get time from localStorage or initialize with initialTime
        const storedTime = localStorage.getItem('timeLeft');
        return storedTime ? parseInt(storedTime, 10) : 0;
    });
    const subjects = Object.keys(questionsData);
    const [selectedSubject, setSelectedSubject] = useState("");

    const getTest = async () => {
        try {
            const response = await axios.post(
                apipath + '/viewTest',
                { id: tId },
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "false") {
                localStorage.removeItem('token');
                navigate('/');
            }
            console.log(response.data);
            const result = response.data;
            const ques = result.questions;
            const subjs = Object.keys(ques);
            setSelectedSubject(subjs[0]);
            setQuestionsData(ques);
            setTotalQuestions(result.totalQuestions);
            setTestData(result.test);
            setImgpath(filepath + "/questionImages_" + result.test?.id + "/");
            if (timeLeft <= 0) {
                setTimeLeft(result.test?.duration * 60);
            }
            // setFilteredData(result.tests);
        }
        catch (error) {
            console.error('Error fetching data:', error);
            if (localStorage.getItem('token')) {
                localStorage.removeItem('token');
            }
            navigate('/');

        } finally {

        }
    }
    useEffect(() => {
        getTest();
    }, []);

    useEffect(() => {
        // console.log(timeLeft);
        if (timeLeft > 0) {
            localStorage.setItem('timeLeft', timeLeft); // Update localStorage
        }

        const timer = setInterval(() => {
            setTimeLeft((prevTime) => {
                const newTime = prevTime - 1;
                if (newTime <= 0) {
                    clearInterval(timer); // Clear the timer when it reaches 0
                    localStorage.removeItem('timeLeft'); // Optional: Clear localStorage
                    return 0;
                }
                return newTime;
            });
        }, 1000);

        return () => clearInterval(timer); // Cleanup on component unmount
    }, [timeLeft]);

    // Format the time as MM:SS
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    };
    
    const handleSubmit = async () => {
        console.log(localStorage.getItem('answers'));
    }

    const [activeTab, setActiveTab] = useState("Test");

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [questionStatus, setQuestionStatus] = useState({}); // To track statuses of questions
    const [selectedAnswers, setSelectedAnswers] = useState(JSON.parse(localStorage.getItem('answers')) || {}); // To track selected options

    const questions = questionsData[selectedSubject] || [];
    const currentQuestion = questions[currentQuestionIndex] || null;

    const handleSubjectChange = (subject) => {
        setSelectedSubject(subject);
        setCurrentQuestionIndex(0); // Show the first question of the selected subject
    };

    const handleSaveAndNext = () => {
        setQuestionStatus({
            ...questionStatus,
            [currentQuestion.id]: 'saved',
        });
        handleNext();
        handleSubmit();
    };

    const handleMarkForReview = () => {
        console.log(currentQuestion);
        setQuestionStatus({
            ...questionStatus,
            [currentQuestion.id]: 'review',
        });
        handleNext();
        handleSubmit();
    };

    const handleNext = () => {
        if (currentQuestionIndex < questions.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
        }
        else if (currentQuestion.id + 1 < totalQuestions) {
            var subind = subjects.indexOf(selectedSubject);
            if (subind < subjects.length) {
                const nextIndex = subind + 1;
                const nextSubject = subjects[nextIndex];
                console.log(nextIndex);
                handleSubjectChange(nextSubject);
            }
        }
    };

    const handlePrevious = () => {
        if (currentQuestionIndex > 0) {
            setCurrentQuestionIndex(currentQuestionIndex - 1);
        }
        else if (currentQuestion.id > 0) {
            var subind = subjects.indexOf(selectedSubject);
            if (subind > 0) {
                const nextIndex = subind - 1;
                const nextSubject = subjects[nextIndex];
                console.log(nextIndex);
                handleSubjectChange(nextSubject);
            }
        }
    };
    useEffect(() => {
        console.log(selectedAnswers);
        localStorage.setItem('answers', JSON.stringify(selectedAnswers));
    }, [selectedAnswers]);
    const handleAttempted = async (option) => {
        setQuestionStatus({
            ...questionStatus,
            [currentQuestion.id]: 'attempted',
        });
        setSelectedAnswers({
            ...selectedAnswers,
            [currentQuestion.qid]: option,
        });
        handleSubmit();
    };

    const getButtonStyle = (index, subject) => {
        // if (subject === selectedSubject && index === currentQuestionIndex) {
        //     return 'border-2 border-black'; // Highlight current question
        // }
        if (questionStatus[index] === 'saved') return 'bg-green-300 text-white';
        if (questionStatus[index] === 'review') return 'bg-orange-500 text-white';
        if (questionStatus[index] === 'attempted') return 'bg-green-700 text-white';
        return 'bg-blue-400 text-white'; // Default for unattempted
    };

    const getOptionStyle = (option) => {
        return selectedAnswers[currentQuestionIndex] === option
            ? 'bg-green-200 border-green-500'
            : 'bg-white';
    };


    return (
        <>
            {<Navbar />}
            <div class="flex flex-col md:flex-row">
                {<Sidebar activePage={"exams"} />}
                <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-2 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6">

                    <div class="bg-gray-800 pt-3">
                        <div class="rounded-tl-3xl bg-gradient-to-r from-blue-900 to-gray-800 p-4 justify-between shadow text-2xl text-white flex flex-col md:flex-row">
                            <span class="font-bold pl-2">Tests</span>
                            <div className="flex flex-row mt-4 md:mt-0">
                                <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-blue-700 border-transparent' : 'bg-transparent border-white'} hover:bg-blue-700 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Exams
                                </span></Link>
                                <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-blue-700 border-transparent' : 'bg-transparent border-white'} hover:bg-blue-700 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                    Tests
                                </span></Link>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-wrap">
                        <div class="w-full p-6">
                            <div className="container mx-auto p-4">
                                <h1 className="mb-3">Time Left: {formatTime(timeLeft)}</h1>
                                {/* Subject Selector as Buttons */}
                                <div className="mb-4 flex space-x-4">
                                    {Object.keys(questionsData).map((subject) => (
                                        <button
                                            key={subject}
                                            onClick={() => handleSubjectChange(subject)}
                                            className={`px-4 py-2 rounded ${selectedSubject === subject ? 'bg-blue-500 text-white' : 'bg-gray-200'
                                                }`}
                                        >
                                            {subject}
                                        </button>
                                    ))}
                                </div>

                                <div className="flex">
                                    {/* Question Display */}
                                    {(currentQuestion) ? <>
                                        <div className="w-3/4 p-4 border rounded shadow-md mb-4">
                                            <h2 className="text-xl font-bold mb-4">
                                                Question {currentQuestion.id + 1}: {currentQuestion.question}
                                            </h2>

                                            {currentQuestion.question_image && (
                                                <img
                                                    src={imgpath + currentQuestion.question_image}
                                                    alt="Question"
                                                    className="w-96 mb-4"
                                                />
                                            )}

                                            <div className="space-y-4">
                                                <label
                                                    className={`block w-full p-3 border rounded cursor-pointer hover:bg-gray-100 ${getOptionStyle(currentQuestion.id + 'a')}`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`question-${currentQuestion.id}`}
                                                        value="a"
                                                        checked={selectedAnswers[currentQuestion.qid] === "a"}
                                                        onChange={() => handleAttempted("a")}
                                                        className="mr-2"
                                                    />
                                                    {currentQuestion.option1 || <img src={imgpath + currentQuestion.option1_image} className="w-84 mb-4 inline" alt="" />}
                                                </label>
                                                <label
                                                    className={`block w-full p-3 border rounded cursor-pointer hover:bg-gray-100 ${getOptionStyle(currentQuestion.id + 'b')}`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`question-${currentQuestion.id}`}
                                                        value="b"
                                                        checked={selectedAnswers[currentQuestion.qid] === "b"}
                                                        onChange={() => handleAttempted("b")}
                                                        className="mr-2"
                                                    />
                                                    {currentQuestion.option2 || <img src={imgpath + currentQuestion.option2_image} className="w-84 mb-4 inline" alt="" />}
                                                </label>
                                                <label
                                                    className={`block w-full p-3 border rounded cursor-pointer hover:bg-gray-100 ${getOptionStyle(currentQuestion.id + 'c')}`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`question-${currentQuestion.id}`}
                                                        value="c"
                                                        checked={selectedAnswers[currentQuestion.qid] === "c"}
                                                        onChange={() => handleAttempted("c")}
                                                        className="mr-2"
                                                    />
                                                    {currentQuestion.option3 || <img src={imgpath + currentQuestion.option3_image} className="w-84 mb-4 inline" alt="" />}
                                                </label>
                                                <label
                                                    className={`block w-full p-3 border rounded cursor-pointer hover:bg-gray-100 ${getOptionStyle(currentQuestion.id + 'd')}`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`question-${currentQuestion.id}`}
                                                        value="d"
                                                        checked={selectedAnswers[currentQuestion.qid] === "d"}
                                                        onChange={() => handleAttempted("d")}
                                                        className="mr-2"
                                                    />
                                                    {currentQuestion.option4 || <img src={imgpath + currentQuestion.option4_image} className="w-84 mb-4 inline" alt="" />}
                                                </label>
                                            </div>

                                            {/* Action Buttons */}
                                            <div className="mt-4 flex space-x-4">
                                                <button onClick={handlePrevious} className="px-4 py-2 bg-gray-300 rounded">
                                                    Previous
                                                </button>
                                                <button onClick={handleNext} className="px-4 py-2 bg-gray-300 rounded">
                                                    Next
                                                </button>
                                                <button onClick={handleSaveAndNext} className="px-4 py-2 bg-blue-500 text-white rounded">
                                                    Save & Next
                                                </button>
                                                <button onClick={handleMarkForReview} className="px-4 py-2 bg-orange-500 text-white rounded">
                                                    Mark for Review
                                                </button>
                                            </div>
                                        </div>
                                    </> : ""}

                                    {/* All Questions Display on the Right */}
                                    <div className="w-1/4 flex flex-col items-center">
                                        <h3 className="text-lg font-bold mb-4">All Questions</h3>
                                        <div className="space-y-2">
                                            {/* Show all questions in serial order */}
                                            {Object.keys(questionsData).map((subject) => (
                                                <div key={subject}>
                                                    <h4 className="font-bold">{subject}</h4>
                                                    {questionsData[subject].map((ques, index) => (
                                                        <button
                                                            key={ques.id}
                                                            onClick={() => {
                                                                setSelectedSubject(subject);
                                                                setCurrentQuestionIndex(index);
                                                            }}
                                                            className={`p-1 m-px border rounded-full w-9 h-9 ${(subject === selectedSubject && index === currentQuestionIndex) ? 'border-2 border-black' : ''} ${getButtonStyle(ques.id, subject)}`}
                                                        >
                                                            {ques.id + 1}
                                                        </button>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};